import React from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { useLang } from "@/context/LanguageContext";

export default function FindoConfirmDialog({ open, text, okLabel, danger, onConfirm, onClose, testid = "findo-confirm" }) {
  const { t } = useLang();
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">{t("fa.confirmTitle")}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription className="text-slate-600">{text}</AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-full" data-testid={`${testid}-cancel`}>{t("fa.goBack")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid={`${testid}-ok`}
            className={`rounded-full font-semibold ${danger ? "bg-findo-danger hover:bg-findo-danger/90" : "bg-findo-navy hover:bg-findo-navy/90 text-white"}`}>
            {okLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
